import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, Linkedin, Globe } from 'lucide-react';

// TikTok icon component (not available in lucide-react)
const TikTokIcon = ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
);

export default function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <Link to="/" className="logo" style={{ marginBottom: '16px' }}>
                            <img
                                src="/atam-logo.svg"
                                alt="ATAM"
                                style={{ height: '28px', width: 'auto' }}
                            />
                        </Link>
                        <p>
                            ATAM Connect is your central hub for discovering Singapore's Indian Heritage and Arts events,
                            workshops, and performances across Singapore. Join our vibrant community
                            celebrating traditional folk arts.
                        </p>
                    </div>

                    <div>
                        <h4 className="footer-title">Quick Links</h4>
                        <div className="footer-links">
                            <Link to="/events" className="footer-link">Events</Link>
                            <Link to="/about" className="footer-link">About Us</Link>
                            <Link to="/founder-note" className="footer-link">Founder's Note</Link>
                            <Link to="/contact" className="footer-link">Contact</Link>
                            <Link to="/partner-portal" className="footer-link">Partner-Portal</Link>
                        </div>
                    </div>

                    <div>
                        <h4 className="footer-title">Contact</h4>
                        <div className="footer-links" style={{ gap: '8px' }}>
                            <span style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
                                1 AMK Industrial Park 2A<br />
                                #06-06 AMK Tech 1<br />
                                Singapore 568049
                            </span>
                            <a href="mailto:admin@atam.sg" className="footer-link">admin@atam.sg</a>
                            <a href="tel:+6589327048" className="footer-link">+65 8932 7048</a>
                        </div>
                    </div>
                </div>

                {/* Social Media Icons */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    padding: '24px 0',
                    borderTop: '1px solid var(--border)',
                    marginTop: '24px'
                }}>
                    <a href="https://www.facebook.com/atam.sg" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: '8px' }}>
                        <Facebook size={20} />
                    </a>
                    <a href="https://instagram.com/atam.sg" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: '8px' }}>
                        <Instagram size={20} />
                    </a>
                    <a href="https://www.youtube.com/@atam_sg" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: '8px' }}>
                        <Youtube size={20} />
                    </a>
                    <a href="https://tiktok.com/@atam.sg" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: '8px' }}>
                        <TikTokIcon size={20} />
                    </a>
                    <a href="https://www.linkedin.com/company/atamsg/" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: '8px' }}>
                        <Linkedin size={20} />
                    </a>
                    <a href="https://atam.sg" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: '8px' }}>
                        <Globe size={20} />
                    </a>
                </div>

                <div className="footer-bottom">
                    <p>© 2026 ATAM Connect. All rights reserved.</p>
                    <div style={{ display: 'flex', gap: '24px' }}>
                        <Link to="/privacy" className="footer-link">Privacy Policy</Link>
                        <Link to="/terms" className="footer-link">Terms & Conditions</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
